import { alpha, type Theme } from "@mui/material/styles";

/** Shared primary button branding for contained / outlined variants. */
export function getBrandedPrimaryButtonStyles(theme: Theme) {
  const primary = theme.palette.primary.main;
  const contrastText = theme.palette.primary.contrastText;

  const containedPrimary = {
    backgroundColor: primary,
    color: contrastText,
    boxShadow: "none",
    "&:hover:not(.Mui-disabled)": {
      backgroundColor: primary,
      boxShadow: "none",
    },
    "&:active:not(.Mui-disabled)": {
      backgroundColor: primary,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  };

  const outlinedPrimary = {
    borderColor: primary,
    color: primary,
    "&:hover:not(.Mui-disabled)": {
      borderColor: primary,
      backgroundColor: alpha(primary, 0.04),
    },
    "&:active:not(.Mui-disabled)": {
      borderColor: primary,
      backgroundColor: alpha(primary, 0.08),
    },
    "&.Mui-disabled": {
      borderColor: theme.palette.action.disabled,
      color: theme.palette.action.disabled,
      backgroundColor: "transparent",
    },
  };

  return { primary, contrastText, containedPrimary, outlinedPrimary };
}

export function getButtonThemeOverrides(theme: Theme) {
  const { containedPrimary, outlinedPrimary } = getBrandedPrimaryButtonStyles(theme);

  return {
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
        },
        containedPrimary,
        outlinedPrimary,
      },
    },
  };
}
